import { fetchMarkProductInMarketResearch } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const MarkProductInMarketResearchKeys = {
    all: ['markproductinmarketresearch'] as const,
    lists: () => [...MarkProductInMarketResearchKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...MarkProductInMarketResearchKeys.lists(), page, perPage, filters] as const,
    details: () => [...MarkProductInMarketResearchKeys.all, 'detail'] as const,
    detail: (params: number) => [...MarkProductInMarketResearchKeys.details(), params] as const,
}

export const useMarkProductInMarketResearchQuery = (SK_PESQUISA: number) => {
    return useQuery({
        queryFn: () => fetchMarkProductInMarketResearch(SK_PESQUISA),
        queryKey: MarkProductInMarketResearchKeys.detail(SK_PESQUISA),
    })
}
